<template>
    <div class="card card-small" v-if="fetched">
        <div class="card-body p-0 pb-3 text-center">
            <table class="table mb-0 responsive-table">
                <thead class="bg-light">
                <tr>
                    <th scope="col" class="border-0 id-cell">ID</th>
                    <th scope="col" class="border-0">Imię i nazwisko</th>
                    <th scope="col" class="border-0">Pesel</th>
                    <th scope="col" class="border-0">Nr dokumentu tożsamości</th>
                    <th scope="col" class="border-0 action-cell">Akcja</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(guarantor, index) in guarantors" :key="guarantor.id">
                    <td>
                        <dt>ID</dt>
                        <dd>{{ guarantor.id }}</dd>
                    </td>
                    <td>
                        <dt>Imię i nazwisko</dt>
                        <dd>{{ guarantor.name}} {{ guarantor.surname}}</dd>
                    </td>
                    <td>
                        <dt>Pesel</dt>
                        <dd>{{ guarantor.pesel}}</dd>
                    </td>
                    <td>
                        <dt>Nr dokumentu tożsamości</dt>
                        <dd>{{ guarantor.id_card}}</dd>
                    </td>
                    <td>
                        <dt>Akcja</dt>
                        <dd class="wsnw">
                            <d-button @click.prevent="editguarantor(guarantor)" class="mr-1 mr-3"><i class="material-icons">edit</i> Edytuj</d-button>
                            <d-button theme="danger"  class="mr-1 mr-3" @click.prevent="removeguarantor(guarantor)"><i class="material-icons">delete</i> Usuń</d-button>
                        </dd>
                    </td>
                </tr>
                </tbody>
            </table>
            <p v-if="guarantors.length < 1" class="text-info">Brak poręczycieli do wyświetlenia.</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "GuarantorsList",
        props: {
            props: {
                type: Array,
                default: ()=>[]
            }
        },
        data(){
            return{
                guarantors: [],
                fetched: true
            }
        },
        methods: {
            editguarantor(guarantor){
                this.$emit('editGuarantor', guarantor)
            },
            removeguarantor(guarantor){
              var name = guarantor.name + ' ' + guarantor.surname;
                Vue.swal({
                    title: 'Uwaga',
                    html: 'Czy potwierdzasz usunięcie<br /><strong>' + name + '</strong><br />z listy poręczycieli?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Tak',
                    cancelButtonText: 'Nie',
                    buttonsStyling: true
                }).then((logout) => {
                    if(logout.value){
                        axios.post('api/guarantors/remove-guarantor', {
                            id: guarantor.id
                        }).then(response => {
                            if (response.data.cannot_delete && response.data.cannot_delete === 1) {
                              Vue.swal({
                                type: 'info',
                                html: 'By usunąć poręczyciela <strong>' + name + '</strong>,<br /> odepnij go najpierw z&nbsp;umów w&nbsp;których uczestniczy',
                                showConfirmButton: true,
                              })
                            } else {
                              this.$emit('removeGuarantor', guarantor.id);
                              Vue.swal({
                                type: 'success',
                                title: 'Poręczyciel został usunięty.',
                                showConfirmButton: true,
                              });
                            }
                        }).catch((errors) =>{
                            console.log(errors);
                        })
                    }
                }).catch((errors) =>{
                    console.log(errors);
                })
            }
        },
        mounted(){
            this.guarantors = this.props ? this.props : this.guarantors;
            this.fetched = true;
        },
        watch: {
            props: {
                handler: function(to) {
                    this.guarantors = to;
                },
                deep: true
            }
        }
    }
</script>

<style>
    .action-cell, .id-cell{
        width: 200px;
    }
</style>
